

















































import { Component, Ref } from 'vue-property-decorator'
import { getResultList } from '@/request/apis/CellTypeAnnotationRequest'
import RouterHelper from '@/mixins/RouterHelper.vue'
import ModuleIntroduction from '@/components/common/ModuleIntroduction.vue'
import ModuleWrapper from '@/components/common/ModuleWrapper.vue'
import StickyButton from '@/components/common/StickyButton.vue'
import ResultWrapper from '@/components/common/ResultWrapper.vue'
import { getCirroUrl } from '@/request/apis/common'
import UpdateButton from '@/components/common/UpdateButton.vue'
import DropdownGroup from '@/components/common/DropdownGroup.vue'

@Component({
  components: {
    DropdownGroup,
    UpdateButton,
    StickyButton,
    ResultWrapper,
    ModuleWrapper,
    ModuleIntroduction
  },
  beforeRouteUpdate (to, from, next) {
    next()
    // @ts-ignore
    this.getResult()
    // @ts-ignore
    this.getCirro()
  }
})

export default class CellTypeAnnotationResult extends RouterHelper {
  @Ref('iframe-wrapper') iframe!: HTMLElement

  private imgUrl: string = ''
  private cirroUrl: string = ''
  private resultList: any[] = ['GeneSetEnrichment', 'PreProcessing'] // 跳转下一步的所有选项

  mounted () {
    this.getResult()
    this.getCirro()
  }

  get id () {
    return this.$route.params.id
  }

  /**
   * 获取结果数据并显示
   */
  private async getResult () {
    const result = await getResultList(null, this.id).start()
    this.imgUrl = result.img_url
  }

  /**
   * 获取cirro的链接，加载时loading
   */
  private async getCirro () {
    try {
      const getCirroRequest = getCirroUrl(this.iframe, { jobId: this.id, type: 'CellTypeAnnotation' })
      this.cirroUrl = await getCirroRequest.start()
    } catch (e) {
      console.log(e)
    }
  }
}
